import { ColorsEnum } from "../../core/et3-theme/colors";

const ALPHA_TINT = "1A";
const ALPHA_HAIRLINE = "1F";
const ALPHA_SHADOW = "0F";
const ALPHA_SHADOW_HOVER = "24";

export const WELCOME_BODY_PADDING_CSS = "clamp(20px, 3vw, 48px)";
export const WELCOME_MAX_WIDTH_CSS = "1120px";
export const WELCOME_BLOCK_GAP = 26;

export const WELCOME_AVATAR_SIZE = 56;
export const WELCOME_HEADER_GAP = 16;
export const WELCOME_GREETING_FONT_SIZE = 30;
export const WELCOME_SUBTITLE_FONT_SIZE = 16;
export const WELCOME_META_FONT_SIZE = 13;
export const WELCOME_TEXT_GAP = 6;
export const WELCOME_ROLE_HEIGHT = 22;
export const WELCOME_ROLE_RADIUS = 7;
export const WELCOME_ROLE_PADDING_X = 9;
export const WELCOME_ROLE_FONT_SIZE = 12;
export const WELCOME_ROLE_LETTER_SPACING = 0.6;

export const WELCOME_SECTION_FONT_SIZE = 14;
export const WELCOME_SECTION_LETTER_SPACING = 0.6;
export const WELCOME_CARDS_GAP = 16;
export const WELCOME_CARD_WIDTH = 260;
export const WELCOME_CARD_HEIGHT = 118;
export const WELCOME_CARD_RADIUS = 14;
export const WELCOME_CARD_PADDING = 18;
export const WELCOME_CARD_GAP = 10;
export const WELCOME_CARD_ICON_SIZE = 17;
export const WELCOME_CARD_BADGE_SIZE = 38;
export const WELCOME_CARD_BADGE_RADIUS = 11;
export const WELCOME_CARD_LABEL_FONT_SIZE = 14;
export const WELCOME_CARD_VALUE_FONT_SIZE = 30;
export const WELCOME_CARD_LINK_FONT_SIZE = 13;
export const WELCOME_CARD_PRESS_OFFSET = 1;

export const WELCOME_CARD_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const WELCOME_CARD_SHADOW = `0 1px 3px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
export const WELCOME_CARD_SHADOW_HOVER = `0 8px 20px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW_HOVER}`;
export const WELCOME_ROLE_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const WELCOME_APPROVE_BADGE = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const WELCOME_REPORTS_BADGE = `${ColorsEnum.darkOrange}${ALPHA_TINT}`;
export const WELCOME_CASES_BADGE = `${ColorsEnum.purple}${ALPHA_TINT}`;
export const WELCOME_TRANSITION =
  "box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1), transform 160ms cubic-bezier(0.4, 0, 0.2, 1)";
